import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchDocumentTemplates } from '../services/documentTemplates';
import type { DocumentTemplateListParams } from '../types/documentTemplates.types';
import { documentTemplateKeys } from './documentTemplateKeys';

export const useDocumentTemplatesQuery = (params: DocumentTemplateListParams) =>
  useQuery({
    queryKey: documentTemplateKeys.list(params),
    queryFn: () => fetchDocumentTemplates(params),
    placeholderData: keepPreviousData,
  });
